import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getContractType } from '../../redux/user/selectors'
import { getPricesMode } from '../../redux/config'
import { PriceVisibility } from '../PriceVisibility'
import { Space } from '../../components/Space'
import { Text } from '../../components/Text'
import { PriceLabel } from '../../components/PriceLabel'
import { Price } from '../../components/Price'

export type PriceWrapperProps = {
  grossValue?: string | undefined
  netValue?: string | undefined
  priceDesc?: string
  showPriceForAnonymousUser?: boolean
}

export const PriceWrapper = ({
  grossValue,
  netValue,
  priceDesc,
  showPriceForAnonymousUser = true
}: PriceWrapperProps) => {
  const { t } = useTranslation('core')

  const contractType = useSelector(getContractType)
  const pricesMode = useSelector(getPricesMode)

  return (
    <PriceVisibility showPriceForAnonymousUser={showPriceForAnonymousUser}>
      <Space space={1} direction="horizontal" flexDirection="row">
        <Text color="primary" bold data-automation-id="priceLabel">
          {PriceLabel({ pricesMode, label: t('core:Price'), netLabel: t('core:PriceSSTExcluded') })}
        </Text>
        <Text color="secondary" bold data-automation-id="priceValue">
          {Price({
            pricesMode,
            contractType,
            grossValue: grossValue || '',
            netValue: netValue || ''
          })}
        </Text>
        <Text ml="10px">{priceDesc}</Text>
      </Space>
    </PriceVisibility>
  )
}
